module.exports = "/packs/images/svg/ireland/facilities/ice_rink~35b0dc1772f8202405d451cd36a592e1.svg";